module.exports = __webpack_public_path__ + "static/media/phoneRed.fff6fd09.svg";